<div *ngIf="downloading" class="clr-row">
  <div class="clr-col">
    <app-loader [displayMode]="'downloading'"></app-loader>
  </div>
</div>
